export default __webpack_public_path__ + "static/media/model_feature-select.7092bdf6.png";